import { FC, CSSProperties } from 'react';
import { useTheme } from '@material-ui/core';
import { WbInfoTooltip } from '../../WbInfoTooltip';
import { WbBadge } from '../../WbBadge';
import { OkFilledIcon } from './Icons';
import { useStyles } from './style';
import { TaskAltIcon } from '../../../icons/TaskAlt';

interface Props {
  style?: CSSProperties;
  variant?: 'reduced' | 'default';
}

export const OkIcon: FC<Props> = ({ style, variant }) => {
  const theme = useTheme();
  const classes = useStyles();

  return (
    <WbInfoTooltip
      variant={variant === 'reduced' ? undefined : 'provided-button'}
      title="Compliant"
      icon={
        variant === 'reduced' ? (
          <span>
            <OkFilledIcon
              htmlColor={theme.palette.success.main}
              className={classes.icon}
              style={style}
            />
          </span>
        ) : (
          <WbBadge color="success" startIcon={<TaskAltIcon fontSize="small" />}>
            Success
          </WbBadge>
        )
      }
    />
  );
};
